import { render, staticRenderFns } from "./modalProductosStock.vue?vue&type=template&id=836b04ca"
import script from "./modalProductosStock.vue?vue&type=script&lang=js"
export * from "./modalProductosStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports